import React from 'react';
import styles from './Hero.module.css';
import zodiacImage from '../../assets/images/horse2026.png';
import ShinyText from '../Shared/ShinyText';

const Hero = ({ onBuyClick }) => {
  const handleCTAClick = () => {
    if (onBuyClick) {
      onBuyClick();
    } else {
      // Fallback: скролл к pricing
      const pricingSection = document.querySelector('[data-section="pricing"]');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className={styles.hero}>
      {/* Подвешенная карточка (в стиле React Bits) */}
      <div className={styles.hangingCardContainer}>
        <div className={styles.cardWithRibbon}>
          <div className={styles.ribbon}></div>
          <div className={styles.swingingCard}>
            <img 
              src="https://strategy.annavision.me/wp-content/uploads/2025/12/38616f85505f2d480684e06e80fa10e4_1766968079_903cour7.webp" 
              alt="Анимированная карточка" 
            />
          </div>
        </div>
      </div>

      {/* Подвешенная лошадь */}
      <div className={styles.hangingContainer}>
        <div className={styles.string}></div>
        <img 
          src="https://strategy.annavision.me/wp-content/uploads/2025/12/0a5523d46491c3f1195b94bb3dfbec15_1766894615_imc4irre-1.webp" 
          alt="Подвешенная золотая лошадь" 
          className={styles.swingingHorse}
        />
      </div>

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.heading}>
            <span className={styles.titleMain}>Прогноз по 9 Дворцам на</span>
            <ShinyText text="2026" className={styles.titleYear} />
            <span className={styles.titleMain}>год</span>
          </h1>
          <p className={styles.subheading}>
            Персональный навигатор, который определит ваше будущее
          </p>
          <p className={styles.description}>
            <span className="year-text">2026</span> год - это не просто еще один год. Это Год Огненной Лошади, переходный период, влияние которого сохранится на следующие 60+ лет. Решения, которые вы примете в этом году, определят ваше будущее на десятилетия вперед. Получите персональный прогноз, рассчитанный индивидуально по вашей карте рождения. Через 21 день вы получите детальный навигатор на весь год с конкретными датами, направлениями, техниками и рекомендациями для планирования успешного <span className="year-text">2026</span> года.
          </p>
          <button className="cta-button" onClick={handleCTAClick}>
            Заказать персональный прогноз за $269 <span className={styles.arrowIcon}></span>
          </button>
        </div>
        {/* 1. Главная картинка - Зодиакальный круг 2026 */}
        <div className={styles.mainImage}>
          <img 
            src={zodiacImage} 
            alt="Золотая лошадь в зодиакальном круге 2026" 
            className={styles.zodiacImage}
          />
        </div>
        
        {/* 4. Автор Zlata Rich */}
        <div className={styles.authorSection}>
          <p className={styles.authorCredit}>Автор: <span className={styles.authorName}>Zlata Rich</span></p>
        </div>
      </div>
    </section>
  );
};

export default Hero;

